import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from "../config";
import { PAY_BOLETO, PAY_PIX, PAY_CREDIT_CARD } from "../helpers";
import ModalPayWithCreditCard from "./ModalPaymentWithCredit";
import ModalPayWithBoleto from "./ModalPaymentWithBoleto";
import ModalPayWithPIX from "./ModalPaymentWithPIX";
import showError from "./ModalError";
import ButtonNext from "./ButtonNext";
import Coupon from "./Coupon";
import { useInvoiceContext, useControlContext } from "../context";

const Total = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [modalPixShow, setModalPixShow] = useState(false);
  const [modalBoletoShow, setModalBoletoShow] = useState(false);
  const [modalCreditCardShow, setModalCreditCardShow] = useState(false);
  const [allTermsAccepted, setAllTermsAccepted] = useState(false);

  const { invoice, setInvoiceID, paymentMethod, cart, invoiceLiquidTotal } =
    useInvoiceContext();

  const { progressViewerCustomer, progressViewerEmail, progressViewerPayment } = useControlContext();

  const [price, cents] = invoiceLiquidTotal.toFixed(2).split(".");
  const formattedCents = cents.padStart(2, "0");

  useEffect(() => {
    setAllTermsAccepted(false);

    // verifica se tem algum produto com termo
    const hasTerms = cart.some((product) => product.tem_termo === "S");

    // verifica se todos os termos foram aceitos, verificando o product.termo_aceito
    console.log(cart);
    let testTerms = cart.every((product) => {
      if (product.tem_termo === "N") {
        return true;
      } else {
        return product.termo_aceito === "1";
      }
    });

    if (hasTerms && testTerms) {
      setAllTermsAccepted(true);
    }
    
    if (
      progressViewerCustomer &&
      progressViewerEmail &&
      progressViewerPayment &&
      cart.length > 0 &&
      (!hasTerms || allTermsAccepted)
    ) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [
    progressViewerCustomer,
    progressViewerEmail,
    progressViewerPayment,
    cart,
    allTermsAccepted,
  ]);

  const handlePaymentModal = (type) => {
    switch (type) {
      case PAY_BOLETO:
        setModalBoletoShow(true);
        break;
      case PAY_PIX:
        setModalPixShow(true);
        break;
      case PAY_CREDIT_CARD:
        setModalCreditCardShow(true);
        break;
      default:
        break;
    }
  };

  const sendPayment = async (event) => {
    event.preventDefault();
    setIsLoading(!isLoading);

    if (paymentMethod === PAY_CREDIT_CARD) {
      handlePaymentModal(paymentMethod);
      setIsLoading(false);
      return;
    }

    try {
      await fetch(`${API_BASE_URL}/invoice/init`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(invoice),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errData) => {
              throw new Error(errData.message);
            });
          }
          return response.json();
        })
        .then((data) => {
          console.log("Success:", data);
          setInvoiceID(data.invoice_id);
          handlePaymentModal(paymentMethod);
          setIsLoading(false);
          setIsDisabled(true);
        })
        .catch((error) => {
          console.error("Error:", error);
          setIsLoading(false);
          showError(error);
        });
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false);
      showError("Erro ao enviar os dados para o servidor.");
    }
  };

  const closePixModal = () => {
    console.log("closePixModal");
    setModalPixShow(false);
    setIsLoading(false);
    setIsDisabled(false);
  }

  return (
    <>
      <ModalPayWithPIX
        show={modalPixShow}
        onHide={() => closePixModal()}
      />

      <ModalPayWithBoleto
        show={modalBoletoShow}
        onHide={() => setModalBoletoShow(false)}
      />

      <ModalPayWithCreditCard
        show={modalCreditCardShow}
        onHide={() => setModalCreditCardShow(false)}
      />

      <div className="mt-4">
        <Coupon
          invoice={invoice}
          cart={cart}
          total={invoiceLiquidTotal}
          price={price}
          formattedCents={formattedCents}
        />

        <Row className="mt-4">
          <Col xs={6}>
            <span style={styles.total}>
              <span style={styles.text}>Total:</span>
              {" " + price}
              <span style={styles.cents}>,{formattedCents}</span>
            </span>
          </Col>
          <Col xs={6} className="d-grid gap-2">
            <ButtonNext
              variant="success"
              text="Pagar"
              faicon={faMoneyBill}
              disabled={isDisabled}
              isLoading={isLoading}
              onClick={(event) => {
                !isDisabled ? sendPayment(event) : console.log("errror");
              }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

const styles = {
  total: {
    fontSize: "25px",
    color: "#333",
  },
  text: {
    fontSize: "20px",
    color: "#333",
  },
  cents: {
    fontSize: "20px",
    color: "#333",
    position: "relative",
    top: "-5px",
  },
};

export default Total;
